export default {
  name: 'dashifydocs:USMap',
  title: 'US Map',
  showPageTitle: true,
  owner: 'System',
  solution: '',
  tags: ['widget', 'svg', 'map', 'usa'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    clickedState: '',
    onStateClicked: "/${ function($e) { $set('/clickedState', $e) } }",
    datasources: {
      selectedState: {
        type: 'jsonata',
        options: {
          expression:
            '$shuffle(["MA","MN","MT","ND","HI","ID","WA","AZ","CA","CO","NV","NM","OR","UT","WY","AR","IA","KS","MO","NE","OK","SD","LA","TX","CT","NH","RI","VT","AL","FL","GA","MS","SC","IL","IN","KY","NC","OH","TN","VA","WI","WV","DE","DC","MD","NJ","NY", "PA", "ME", "MI", "AK"])[0]',
        },
        refetchInterval: 2000,
      },
    },
    view: [
      [
        'div',
        {
          '.': 'px-9 pb-6 flex flex-col gap-6',
          style: {
            minWidth: '800px',
            height: '600px',
          },
        },
        [
          [
            'dashify:Container',
            {
              title: '/${ clickedState.attributes.id ? "Clicked State: " & clickedState.attributes.id : "" }',
            },
            [
              [
                'dashify:SvgJson',
                {
                  content:
                    '/${ ($clickedState :=clickedState.attributes.id;$randomState:= data.selectedState.data; $elem := usmapsvg.children[attributes.id in [$clickedState, $randomState]]~> |attributes| {"style":"fill:#7A3FD6;stroke:#888;"}|; $newChildren := usmapsvg.children ~> $append($elem); usmapsvg ~>|$|{"children":$newChildren}| ) }',
                  onClick: '/${ onStateClicked }',
                },
              ],
            ],
          ],
        ],
      ],
    ],
    usmapsvg: {
      name: 'svg',
      type: 'element',
      value: '',
      attributes: {
        id: 'svg',
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 973.43 532.58',
      },
      children: [
        {
          name: 'defs',
          type: 'element',
          value: '',
          attributes: {},
          children: [
            {
              name: 'style',
              type: 'element',
              value: '',
              attributes: {},
              children: [
                {
                  name: '',
                  type: 'text',
                  value:
                    '\n      .cls-1 {\n        fill: #8e98fc; opacity:0.3;\n        fill-rule: evenodd;\n        stroke: #A0A0A0;\n        stroke-miterlimit: 10;\n      }\n    ',
                  attributes: {},
                  children: [],
                },
              ],
            },
          ],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'MA',
            class: 'cls-1',
            d: 'm947.05,131.83l-.29-.19v.29l.29-.1h0Zm-2.91-2.62l.68-.29v-.39l-.68.68h0Zm12.04-7.57l-.1-1.36-.19-.78.29,2.14Zm-42.42-10l-.68.29-5.53,1.65-1.94.68-2.23.68-.78.29v.29l.29,5.05.29,4.66.29,4.27.49.29,1.75-.49,7.86-2.33.19.49,13.98-5.34.1.19,1.26-.49,4.46-1.75,4.27,5.14h0l.58-.49.29-1.46-.1,2.33h.97l.29,1.16.87,1.65h0l4.56-5.53,3.79,1.26.87-1.94,6.21-3.3-2.62-5.14.68,3.3-3.2,2.43-3.59.29-7.18-7.67-3.2-4.85,3.2-3.4-3.3-.19-1.36-3.2-.1-.19-5.53,6.02-12.23,4.08-3.98,1.26h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'MN',
            class: 'cls-1',
            d: 'm549.29,52.62l1.94,6.89,4.08,24.85,1.94,9.9.58,8.74,2.23,5.24.49,4.46.39,1.46-.1.29-3.88,6.41,2.52,4.27,4.85,34.17.19,4.46,4.85-.29,19.12-1.07,47.76-3.98,4.76-.49v-.49l-1.36-7.47-5.92-3.01-4.66-4.85-7.38-4.46-2.33-.19-3.59-2.72.97-13.39-3.4-3.11,1.16-5.44,6.21-5.63-1.07-11.65,2.23-2.52h0l7.57-7.96,8.64-11.07,3.3-2.33,5.82-2.81,6.11-4.56-4.08.78-2.43-1.84-9.32,1.26-1.46-1.75-8.35,3.4-6.7-2.81-1.84-2.23-5.34.39-3.59-1.84,1.16-1.36-4.56-1.46h-4.08l-6.5,2.81-1.26-1.94-10.29-1.46-3.49-8.74-.39-2.62-4.46-1.26.39,7.47-11.84.87-14.66.58-.97.1h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'MT',
            class: 'cls-1',
            d: 'm456.4,51.75l-32.13-2.14-23.39-2.23-23.3-2.72-14.46-1.94-23.1-3.59-11.55-1.94-25.82-4.95-2.72-.58-4.17,19.8,1.84,3.59,1.46,5.53-.87.78,1.84,5.05,2.52,2.14,7.18,12.04.68,2.04,2.91-.19-3.4,15.92-1.36.39-1.84,5.34,9.61.68.78,4.46,5.44,13.3.97.78,3.79,7.77.97-.78,8.06-.1,10.19,1.07,2.52-3.3,3.01,5.44.58.29.1-.58,1.36-9.51,33.2,4.08,26.5,2.52,13.98,1.16,24.95,1.46,1.26.1h.29l.1-1.36.29-6.7.39-8.83.1-2.23.19-3.88,1.55-30.48,1.26-23.68.1-3.88-1.84-.1h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'ND',
            class: 'cls-1',
            d: 'm547.25,52.62l-29.31.58-20.48-.1-17.57-.39-20.58-.78-1.07-.1-.1,3.88-1.26,23.68-1.55,30.48-.19,3.88,3.79.19,42.8,1.16,39.5-.29,16.4-.49,3.3-.19-.39-1.46-.49-4.46-2.23-5.24-.58-8.74-1.94-9.9-4.08-24.85-1.94-6.89h-2.04,0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'HI',
            class: 'cls-1',
            d: 'm407.09,493.78l-3.01-2.23-2.62.68.58,5.44-3.59,4.46,3.11,7.09.87,7.28,3.59,2.33,2.23-3.59,3.98-2.91,4.85-1.26,5.34-4.56-5.24-4.46-.1-2.72-10-5.53h0Zm-17.67-7.86l-1.46-1.26-1.36,1.84,2.81-.58h0Zm-7.28-4.17l.39-3.59-1.84-.29,1.46,3.88h0Zm6.11-5.92l-1.65.78,1.16,3.69,2.52.19.78,3.2,2.72,1.16,6.02-2.81-5.63-4.66-5.92-1.55h0Zm-12.42-3.98l-.87,2.62,4.17-.1,3.88.97-2.04-3.2-5.14-.29h0Zm-12.23-7.67l-2.23-2.14-4.27,3.3,2.72,5.05,1.94-2.04,5.53,1.16-.49-2.33-3.2-3.01h0Zm-43.48-4.27l.58-1.36,1.65-.87-2.23,2.23h0Zm15.43-8.83l-6.79,2.52-.68,1.84,2.72,1.94,3.79.97,2.72-5.34-1.75-1.94h0Zm-47.08-17.86v-.1h-.19l.19.1Zm-51.44-12.72v.19h.1l-.1-.19Zm-26.98-4.46l.1.1h0l-.1-.1Zm-1.07-1.94h0Zm-.87-.97h-.19v.1l.19-.1Zm.68,0h-.1.1Zm-.1-.1h0v.1-.1Zm-30.48-25.04l-.1-.29v.1l.1.19h0Zm-66.49-21.26l-.29.29.19.1.1-.39h0Zm-70.37-49.02h0Zm2.43.1h-.1.1Zm-.49-.1h0ZM1.85,299.55l.29-.1v-.19l-.29.29h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'ID',
            class: 'cls-1',
            d: 'm299.84,31.66l-8.64-1.75-2.81-.68-1.26-.29-11.26,50.67.49,4.17-.39,4.37.19.97v.1l.1,1.84,3.3,3.59-4.76,11.94-10.09,13.2-.29,2.43,2.62,6.21-9.22,38.24-.39,2.04,2.72.58,27.47,5.44,10.97,2.04,2.81.49,2.72.49,13.98,2.23,25.04,3.79,2.81.39.39-3.2.87-6.31,3.3-25.24,1.75-12.52.39-3.2-.58-.29-3.01-5.44-2.52,3.3-10.19-1.07-8.06.1-.97.78-3.79-7.77-.97-.78-5.44-13.3-.78-4.46-9.61-.68,1.84-5.34,1.36-.39,3.4-15.92-2.91.19-.68-2.04-7.18-12.04-2.52-2.14-1.84-5.05.87-.78-1.46-5.53-1.84-3.59,4.17-19.8h-.1,0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'WA',
            class: 'cls-1',
            d: 'm182.87,55.83l.1-1.65-.19.1.1,1.55h0Zm20.67-8.83l.58-.97-.68-.1.1,1.07h0Zm-1.84-1.75l.58-1.94-.58-.19v2.14Zm7.09-2.81l-.1-1.94-1.65,2.52,1.75-.58h0Zm.19-4.08l.29-1.94-.19-.49-.1,2.43h0Zm.29-9.51l-.1-1.07-.39-.1.49,1.16h0Zm3.11-6.41l-.87-.1-1.75,2.72,2.62-2.62Zm-2.43-2.62l.49-.39.1-.29-.58.68h0Zm-.49.29l-.29-1.94-.87,1.65,1.16.29h0Zm-.49-2.72l-.87-.39.68.97.19-.58h0Zm2.91,1.65v-1.26l-.29.49.29.78Zm.87-1.26l-.39-.29h-.1l.49.29h0Zm-5.53-2.14l-.49-.39-.19-.1.68.49Zm3.59-.39l-2.62.68.68.19,1.94-.87Zm-2.14-.19l-.49-.58-.1.1.58.49h0Zm2.04-1.16h-.39l.49.19-.1-.19h0Zm-19.02,49.79l3.49,3.79-.58,7.28.68,1.84,5.24,2.81,14.75,1.36.58,1.75,6.99.1,6.6.87,10.77-1.16,5.34.87,1.46-.68,27.27,6.21,1.84.39-.19-.97.39-4.37-.49-4.17,11.26-50.67-1.55-.29-22.71-5.34-19.8-5.05-22.42-6.21-6.7-1.65,1.55,8.44-1.46,2.72-2.62-1.36,2.52,11.74-2.72,3.88-1.26,3.59v3.69l-5.73,3.98-2.43-1.55-2.33,1.16,4.27-5.53-1.07,3.79,2.43-2.62,1.94.39-.58-4.85,1.26.19,2.62-5.82-.87-.87-3.4,4.37-2.23.1,2.43-2.72,2.72-.68-.97-4.95-2.72-.68-1.36-2.33-1.65.87-8.93-3.88-7.86-6.11-2.14,5.92-.19,2.52,1.65,4.46-1.07,14.46-.78,2.23,4.37.39-4.37,3.11,2.33,1.16-1.84,6.21-.87-4.85-1.65,5.63,2.23,2.72,2.43-.19,2.91,1.75,1.46,2.81h1.75,0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'AZ',
            class: 'cls-1',
            d: 'm362.93,288.68l-32.71-4.08-17.57-2.52-25.04-3.98-2.52-.39v.19l-4.27,18.83-2.23-.1-3.4-3.01-4.27,3.59-.1,15.43-1.55,3.3v.39l-.19,2.43,3.4,9.12,3.01,4.08-5.44,3.2-2.14,3.98-3.49,8.54-1.75.39-.1,7.09,3.01,2.23-1.55,4.27-3.49.19h0l-2.04,3.79,6.99,4.37,13.2,7.38,40.77,21.65,34.55,4.27h.39l2.72-28.63.68-7.09,7.28-75.13.39-3.49-2.52-.29h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'CA',
            class: 'cls-1',
            d: 'm196.75,342.55l.39,2.14v.39l-.39-2.52h0Zm-14.27-8.35l.68,1.46.39-.1-1.07-1.36h0Zm16.99-.29l.29,2.52,1.75,1.26-2.04-3.79Zm-11.74-13.78l-1.07-.29.87.39.19-.1h0Zm-10.77-2.91l-2.62,1.55.68.68,1.94-2.23Zm-5.05-1.84l-.19.78.87.19-.68-.97h0Zm8.54,1.94l4.27,2.43.78-.68-5.05-1.75Zm-33.1-85.51l-.1.1.1-.1h0Zm10.39.49l-.1-.29v.39l.1-.1h0Zm56.01-73.67l-3.79-.97-41.54-11.45-15.43-4.66v.39l-.87,9.61-4.08,11.36-6.79,8.44-.19,4.27,3.3,5.92,1.65,7.77-2.33,6.31.39,6.31-1.16,2.62,3.98,8.64,2.52,3.3-.19,9.42,6.02,5.73,3.49-5.82,3.79,3.01,1.46-1.36-5.24.97-.1,4.95,1.07,6.21-2.91-2.81-1.65-3.79-.49,5.24,1.36,10.39,5.44,6.7-3.59,4.66.58,5.92,3.88,6.02,6.79,18.64,2.14,1.16-.68,12.91,1.07,1.55,14.56,5.24,4.46,4.76,1.55,3.11,4.27,2.43,4.66.87,1.94,5.34,3.88,1.84,5.82,6.89,5.44,9.03-.39,8.35,3.01,3.98,39.7,3.88h0l3.49-.19,1.55-4.27-3.01-2.23.1-7.09,1.75-.39,3.49-8.54,2.14-3.98,5.44-3.2-3.01-4.08-3.4-9.12.19-2.43v-.1l-2.52-3.4-7.77-10.39-15.04-21.16-20.97-30.09-11.84-16.4-11.45-16.5,13.2-56.01.87-3.69h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'CO',
            class: 'cls-1',
            d: 'm480.37,234.33l.39-19.02-4.66-.19-23.68-.87-2.33-.1-1.94-.1-28.83-1.84-19.22-1.55-23.97-2.33-2.33-.29-.29,2.52-5.24,50.57-1.84,17.67-.78,7.67-.19,2.52,3.01.29,48.92,4.27,21.55,1.36,21.45.97,3.11.1,1.94.1,4.08.1,1.94.1,6.11.19h1.55v-1.94l1.07-51.35.1-5.73v-1.84l.1-1.26h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'NV',
            class: 'cls-1',
            d: 'm285.57,274.61l10.09-62.8,5.14-31.45.58-3.11-2.81-.49-10.97-2.04-27.47-5.44-2.72-.58-2.72-.58-13.69-3.01-24.56-5.82-2.72-.68-.87,3.69-13.2,56.01,11.45,16.5,11.84,16.4,20.97,30.09,15.04,21.16,7.77,10.39,2.52,3.4v-.29l1.55-3.3.1-15.43,4.27-3.59,3.4,3.01,2.23.1,4.27-18.83v-.19l.49-3.11h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'NM',
            class: 'cls-1',
            d: 'm463.19,303.53l.1-2.52.1-2.52.1-2.52-3.11-.1-21.45-.97-21.55-1.36-48.92-4.27-3.01-.29-.39,3.49-7.28,75.13-.68,7.09-2.72,28.63.39.1,13.39,1.26,1.26-6.79,2.43-1.94,27.18,2.43h.19l-2.43-4.76,12.33.87,30.77,1.75,19.22.87,3.3-91.05.68.1.1-2.62h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'OR',
            class: 'cls-1',
            d: 'm152.98,141.53l15.43,4.66,41.54,11.45,3.79.97,2.72.68,24.56,5.82,13.69,3.01,2.72.58.39-2.04,9.22-38.24-2.62-6.21.29-2.43,10.09-13.2,4.76-11.94-3.3-3.59-.1-1.84v-.1l-1.84-.39-27.27-6.21-1.46.68-5.34-.87-10.77,1.16-6.6-.87-6.99-.1-.58-1.75-14.75-1.36-5.24-2.81-.68-1.84.58-7.28-3.49-3.79-.29.1-.68.49-4.85-2.52-2.91.87-1.94-.97-2.04,8.35-1.36,2.33-6.02,14.66-1.75,8.06-1.07.1-5.63,13.39-3.79,5.73-1.36.97-3.49,6.79-.68,7.18-2.14,6.41,1.26,5.82v.1h0Zm35.53-79.69l-.29-.87-.1.68.39.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'UT',
            class: 'cls-1',
            d: 'm343.13,183.76l-25.04-3.79-13.98-2.23-2.72-.49-.58,3.11-5.14,31.45-10.09,62.8-.49,3.11,2.52.39,25.04,3.98,17.57,2.52,32.71,4.08,2.52.29.19-2.52.78-7.67,1.84-17.67,5.24-50.57.29-2.52-1.94-.19-24.75-3.01-3.79-.49,2.43-18.93.19-1.26-2.81-.39h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'WY',
            class: 'cls-1',
            d: 'm452.13,170.94l.78-15.14.97-20.38.1-2.52-1.26-.1-24.95-1.46-13.98-1.16-26.5-2.52-33.2-4.08-1.36,9.51-.1.58-.39,3.2-1.75,12.52-3.3,25.24-.87,6.31-.39,3.2-.19,1.26-2.43,18.93,3.79.49,24.75,3.01,1.94.19,2.33.29,23.97,2.33,19.22,1.55,28.83,1.84,1.94.1.1-2.52.49-10.19.87-17.76.39-7.57.1-2.52.1-2.62h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'AR',
            class: 'cls-1',
            d: 'm681.2,306.83l-10.48,1.55,4.27-6.79-1.84-3.79-36.98,3.59-31.25,2.52-4.56.29.58,2.72,3.79,19.61.1,4.37,1.07,26.4.1,4.37.29.1,1.46,1.55,5.82-.19.58,8.54.19,2.43,3.01-.29,9.22-.68,36.59-3.4h.19l-.1-2.14.97-.68-1.75-3.3,3.69-15.53-1.46-1.75,5.53-6.11-.39-5.24,4.08-6.79v-.1l-.19-.19,3.49-3.2-.97-3.88,2.72-4.27-.58-3.98,2.91-5.63v-.1h-.1Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'IA',
            class: 'cls-1',
            d: 'm652.27,176.48l-5.34-2.81-2.91-3.98-.97-5.73.78-2.62-2.81-3.4h0l-4.76.49-47.76,3.98-19.12,1.07-4.85.29-2.04.1,1.65,10.77-1.36,5.14,2.14,3.2v.68l.68.1,3.11,9.12,3.01,4.76.19,5.44,3.3,4.56-.58,1.94,3.01,12.23v.29h0l19.9-.58,21.26-1.84,20.87-2.62,4.76,4.17.19.19.87-.39-.68-3.79,3.59-2.23,1.46-9.9-1.46-.68.87-5.05,4.37-.87,4.85-3.49,2.14-6.11.1-3.11-3.88-3.69-1.16-2.33-3.69-2.33.19-.49.1-.49h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'KS',
            class: 'cls-1',
            d: 'm599.66,291.5l-2.43-41.06-4.37-2.52-.39-1.94-3.49-3.11,3.4-4.17-1.36-2.43-2.52.1-2.33-1.65-.97-.78-3.3.19-35.82,1.36-16.4.39h-32.61l-13.1-.19-3.69-.1v1.84l-.1,5.73-1.07,51.35v1.94l4.17.1,22.52.29,52.71-.78,37.56-1.75,3.69-.29-.1-2.52h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'MO',
            class: 'cls-1',
            d: 'm644.41,221.22l-4.76-4.17-20.87,2.62-21.26,1.84-19.9.58h0l-.1.58,2.43,4.66,2.23,1.55,2.62,4.66.39.39.97.78,2.33,1.65,2.52-.1,1.36,2.43-3.4,4.17,3.49,3.11.39,1.94,4.37,2.52,2.43,41.06.1,2.52.19,2.52.1,2.52.19,2.62.1,2.52,4.56-.29,31.25-2.52,36.98-3.59,1.84,3.79-4.27,6.79,10.48-1.55h.1v-.78l.19-4.46,1.94-2.43-.58-2.72-.1-.1-.1-.1.39-1.26.58.19.29.78-.1.29v.87l.39.1.78-.97v-.1l.1-.29,2.52-1.55.39-.19.87-7.96-.19-.39-.29-.1-6.89-5.63,1.07-2.04-1.94-5.53-3.49-2.72-6.6-2.91-4.17-3.4.49-6.99,1.26-6.5-6.99.39-2.14-2.23-.97-4.46-11.07-9.32-3.11-8.64.78-4.27h0l-.19-.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'NE',
            class: 'cls-1',
            d: 'm563.07,183.46l-3.01-3.01-10.58-3.11-3.4-.1-5.14,1.46-6.11-3.88-19.12.19-27.86-.29-32.9-1.07-2.91-.1-.1,2.52-.39,7.57-.87,17.76-.49,10.19-.1,2.52,2.33.1,23.68.87,4.66.19-.39,19.02-.1,1.26,3.69.1,13.1.19h32.61l16.4-.39,35.82-1.36,3.3-.19-.39-.39-2.62-4.66-2.23-1.55-2.43-4.66.1-.58v-.29l-3.01-12.23.58-1.94-3.3-4.56-.19-5.44-3.01-4.76-3.11-9.12-.68-.1-1.84-.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'OK',
            class: 'cls-1',
            d: 'm600.25,301.69l-.19-2.62-.1-2.52-.19-2.52-3.69.29-37.56,1.75-52.71.78-22.52-.29-4.17-.1h-1.55l-6.11-.19-1.94-.1-4.08-.1-1.94-.1-.1,2.52-.1,2.52-.1,2.52-.1,2.62h.58l23.49.58,24.85.29.29,33.2,1.75,5.82,3.88,3.69,4.17.19.87-1.75,5.73,5.24,7.47.78,1.36,1.55,2.72-1.26,6.79,3.2v1.84l2.52-.1,2.62-2.23,4.85,3.11,4.56,1.65,3.11-4.27,9.9,4.66,3.69-3.01,3.01-1.16,2.43.58,9.12-2.62,4.85,2.04,4.37,2.81,3.79.68h.1l-.1-4.37-1.07-26.4-.1-4.37-3.79-19.61-.58-2.72-.1-2.52h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'SD',
            class: 'cls-1',
            d: 'm557.63,114.36l-16.4.49-39.5.29-42.8-1.16-3.79-.19-.1,2.23-.39,8.83-.29,6.7-.1,1.36h-.29l-.1,2.52-.97,20.38-.78,15.14-.1,2.62,2.91.1,32.9,1.07,27.86.29,19.12-.19,6.11,3.88,5.14-1.46,3.4.1,10.58,3.11,3.01,3.01,1.84.19v-.68l-2.14-3.2,1.36-5.14-1.65-10.77,2.04-.1-.19-4.46-4.85-34.17-2.52-4.27,3.88-6.41.1-.29-3.3.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'LA',
            class: 'cls-1',
            d: 'm679.74,448.06l-1.26.29-.58.58,1.84-.87h0Zm4.08,0l-.68-.29-.19.29h.87Zm2.33-.78h-.68l-.39.49,1.07-.49Zm-1.16-.68l-.19-.29-.1.29h.29Zm7.77-5.14l-.29.19h.49l-.19-.19h0Zm13.59-5.73l.58-.78-.68.87.1-.1h0Zm1.94-2.52l-.19.1v.1l.19-.19h0Zm-49.89,8.54l1.46-1.84-3.98-1.07-1.75,1.46,4.27,1.46h0Zm40.28-8.44l-.39-.39-.1.19.49.19h0Zm1.07-1.75l-.97-.29.29.97.68-.68Zm7.96-1.65v-.29.29h0Zm1.94-1.26l-.1-.1.1.19v-.1h0Zm-.78-.19l-.19-.1-.1.29.29-.19h0Zm-6.79-.29l.87-.29v-.29l-.87.58h0Zm.49-.49l.49-.49-.1-.1-.39.58h0Zm-3.4-3.59l-.19.19h.1l.1-.19h0Zm-35.82-54.36h-.19l-36.59,3.4-9.22.68-3.01.29.1,2.33,1.94,18.73,3.2,4.46.1,2.62,3.11,5.44,2.52,7.96-.87,4.46-.68,11.07-1.46,3.59h.19l.29,2.52-1.65,2.33,12.04-1.36,9.42,2.62,6.7.87,3.4-2.43-1.84-2.43,6.21-1.94-.19,2.14,3.2-.78,2.62,4.08,2.23-.78,5.82,3.98-3.59,1.26,8.25,2.43h3.11l1.84-2.23,3.98-2.14,2.81,4.08,1.94-3.69-.58-5.82,5.24,2.04.58,1.75,6.21.78,3.11,2.52-.39,2.04,4.37-4.08-1.65-2.14-7.28-1.84-2.72-1.55-.1-2.91,3.01.39,2.33-4.76-3.01-4.17-1.65,3.98-3.79-.68,2.62-4.27-1.75-.49-4.27,3.01-6.11.39-1.75-1.36,2.81-4.95,3.3-.1,5.63,1.84,4.08.39h0l-2.23-2.81-4.27-8.35,1.16-4.66-33.49,3.69,1.26-1.26-1.36-3.49,2.04-3.01,1.16-7.57,7.38-12.62-3.59-4.37.19-3.2-2.23-5.24v-.68h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'TX',
            class: 'cls-1',
            d: 'm564.72,515.71l-4.66-17.57v3.3l4.66,14.27Zm-1.07-30.87l-3.3,6.21-.39,2.04,3.69-8.25h0Zm2.62-4.56l3.11-4.08-2.23,1.36-.87,2.72Zm10.97-9.9l-7.28,3.79,2.04-.39,5.24-3.4Zm.97-1.36l2.04-1.65-.78.19-1.26,1.46Zm-115.12-162.87l-.68-.1-3.3,91.05-19.22-.87-30.77-1.75-12.33-.87,2.43,4.76.1.1,10.48,10.48,6.02,7.09,7.96,5.92,5.63,10.29,2.14,10.77,4.56,3.01,3.59,3.98,5.14,1.84,7.47,4.76,3.4,1.26,4.66-4.66,1.46-4.95,2.43-4.76,7.57-3.01,2.91,1.46,8.44.68,7.67,4.76,5.24.97-1.46,2.72,3.01,1.94,2.81,3.4.58,3.59,1.84,2.43,4.27,10.29,4.27,3.59,3.3,5.44,4.17,4.27,1.84.58,1.55,11.07,4.56,2.52.19,3.49,1.16-.29,7.96,9.71,3.98.87,5.05,3.01h7.77l5.63,3.11,6.7-1.46-3.01-2.81-2.72-8.15-1.07-7.09-1.55-2.33.68-4.76-2.04-.19-2.72-4.46,3.11,3.3,3.59-1.26,1.94-5.14-3.88-5.24,5.82.68,2.72-4.17-.39-1.46,2.43-3.2-.58,2.81,2.72-2.14-1.07-3.79,3.49,1.84,4.46-2.52-4.37-4.56,2.72,1.07,5.05.29,6.6-1.46,7.38-4.95,4.46-3.69.68-2.72,2.72-2.81-1.46-4.66.29-2.91,4.85-2.14-.39,5.14h2.91l-3.2,2.72,12.91-6.79,2.14-.1,1.36-6.21h.39l1.46-3.59.68-11.07.87-4.46-2.52-7.96-3.11-5.44-.1-2.62-3.2-4.46-1.94-18.73-.1-2.33-.19-2.43-.58-8.54-5.82.19-1.46-1.55-.29-.1h-.1l-3.79-.68-4.37-2.81-4.85-2.04-9.12,2.62-2.43-.58-3.01,1.16-3.69,3.01-9.9-4.66-3.11,4.27-4.56-1.65-4.85-3.11-2.62,2.23-2.52.1v-1.84l-6.79-3.2-2.72,1.26-1.36-1.55-7.47-.78-5.73-5.24-.87,1.75-4.17-.19-3.88-3.69-1.75-5.82-.29-33.2-24.85-.29-23.49-.58h-.58,0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'CT',
            class: 'cls-1',
            d: 'm927.74,122.12l-13.98,5.34-.19-.49-7.86,2.33-1.75.49.19.97,3.69,14.27,1.16,1.46-2.52,3.11,1.75,1.65h0l5.63-5.44,3.01-4.17.58,1.16,14.17-6.31.29-.29-.1-2.33-.58-2.04-3.01-8.44-.39-1.07-.1-.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'NH',
            class: 'cls-1',
            d: 'm914.63,54.76l-1.26,1.55-1.46-.29-.78,6.41v.1l2.33,8.74-.19,1.75-4.17,5.53,1.07,5.05v6.31l-.78,5.82,4.37,15.92h0l3.98-1.26,12.23-4.08,5.53-6.02h0v-1.55l.29-2.52-.68.29-.1-.58-6.11-7.47-.19-.68-14.07-33h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'RI',
            class: 'cls-1',
            d: 'm937.25,130.86l-.1-2.04-.29.78.39,1.26h0Zm1.94-1.55l-1.26-2.43-.1,2.52,1.36-.1h0Zm-.58-3.01l.68,1.75.87,1.55.58-1.16-.87-1.65-.29-1.16h-.97v.68Zm-10.77-3.98l.39,1.07,3.01,8.44.58,2.04.1,2.33.19-.29,4.66-3.69-.87-6.6,1.94-.39h0l-4.27-5.14-4.46,1.75-1.26.49h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'VT',
            class: 'cls-1',
            d: 'm913.76,111.64l-4.37-15.92.78-5.82v-6.31l-1.07-5.05,4.17-5.53.19-1.75-2.33-8.74-1.26.49-5.34,1.94-5.24,2.04-12.04,4.37-.68.19,4.37,10.19,1.46,9.61,5.14,8.06,4.85,15.92.19-.1.78-.29,2.23-.68,1.94-.68,5.53-1.65.68-.29h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'AL',
            class: 'cls-1',
            d: 'm709.05,323.62l.39.78,1.36.87.58,39.8.19,21.84,4.95,29.9.39-.1,4.37.87,1.16-8.64,1.94,4.85,3.3,3.01,6.31-3.69-.68-.58.19.1-4.37-10,41.93-6.79,2.81-.49v-.1l-2.62-4.95-.19-7.09-2.14-3.88,1.07-7.57,1.75-1.94-7.18-12.81-13.01-39.6-.1-.19-2.91.49-15.53,2.52-7.77.97-16.31,2.23.1.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'FL',
            class: 'cls-1',
            d: 'm845.43,514.06h-.19l.1.1.1-.1h0Zm-.87-.1v.1h.1l-.1-.1Zm.19-.1v-.1.1h0Zm-13.2,1.46h0v.1-.1Zm-.19.1v-.1.1h0Zm.1-.1h0Zm-.97.1h-.1v.1l.1-.1Zm27.57-6.11h-.1l.1.19v-.19Zm2.62-.68v-.19l-.19.29.19-.1h0Zm-.97-.19l-.39-.39-.1.1.49.29h0Zm-.29.78l-1.16-1.46.68,1.26.49.19h0Zm9.22-5.73v.39l.19-.19-.19-.19Zm1.36-.97l.29-.49-.39.39.1.1h0Zm.29-.97h-.1v.1l.1-.1Zm-1.75-.29l-.1-.1.1.1h0Zm.87-1.46l-.1-.1v.19l.1-.1h0Zm-2.62-.1l-.1-.1.1.1h0Zm3.3-2.23l-.19.1.29.1-.1-.19h0Zm.39,0l-.19-.19.1.29.1-.1h0Zm-.68-.19l-.1-.1v.19l.1-.1h0Zm3.59-.68v-.1l-.19.39.19-.29h0Zm-4.08.39h-.19l.19.1v-.1Zm2.04-1.16h-.29l-.1.1.39-.1h0Zm.78-.49h-.1.1Zm-8.15.39v-.19l-.1.19h.1Zm.87-.29h-.29l.29.58v-.58Zm-2.33.1v-.58l-.49.1.49.49Zm-1.36-.97l.49.49v-.19l-.49-.29h0Zm14.27.58l-1.75.78.58.1,1.16-.87Zm-13.59-.87h-.58v.19l.58-.19Zm15.34-4.85l.1-.49.1-1.26-.19,1.75h0Zm.1-5.44l-.39-.97-.19.39.58.58Zm-22.42,2.43l-.19.29.49.1-.29-.39h0Zm-1.84-.87l-.87.29.68.1.19-.39h0Zm-1.94.19v-.29l-.1.1.1.19h0Zm-2.04-.1l-.58.39.78.39-.19-.78h0Zm2.72.1l-.1-.29-.49-.1.58.39h0Zm-12.72-9.51l-.58.29,1.16.39-.58-.68h0Zm-2.33-3.11l-.78-1.16.29.87.49.29h0Zm3.01,1.94l-1.36-3.11-.97-.29,2.33,3.4Zm-3.88-3.88l-.29-.78-.19-.49.49,1.26h0Zm-8.06-10.77l-1.75-1.26.68.68,1.07.58Zm43.68-6.5l-7.09-11.84h-.39l7.47,11.84h0Zm-49.02-18.93l-.29-.1.29.19v-.1h0Zm-.58-.68l-.1.1.1.1v-.19h0Zm-.68-.97v-.1l-.1.1h.1Zm.39-.39l.29.19v-.19h-.29Zm.58-.39l-.39.1h.1l.29-.1h0Zm-.68-.1l-.29-.29.1.1.19.19h0Zm-.68-1.07h-.19l.29.1-.1-.1h0Zm.68-1.16h-.39l-.1.1.49-.1h0Zm.39.19l-.49-.49.19.1.29.39h0Zm-3.69-4.17l-.19-.1v.1h.19Zm-4.17,0l-.29-.39.1.49.19-.1h0Zm-35.33-3.2l2.91-2.23-3.2,2.14.29.1h0Zm5.82-4.66l.29-.29-1.16.49.87-.19h0Zm-36.88-6.5l-10.58,3.4,5.82-1.65,4.76-1.75Zm26.3-16.5l-2.81.49-41.93,6.79,4.37,10,.29.1-1.07,3.98,3.11-1.36,3.4-3.01,5.82-.19,6.7-2.43,4.56.68-1.07,1.65,8.35,2.81,7.18,3.49,1.65,3.88,5.34-1.16,12.62-10.29,4.66.19,19.02,14.37,3.88-.78,4.08,5.44.78,8.64-1.26,5.44.58,2.72,3.4,6.79-1.55-5.34,4.37-.1.39,3.88-2.33,6.02,8.06,11.07,3.01.1-2.52-3.4,3.11.39,1.84-1.16-.78,6.21,4.17,3.3,2.81,7.57,3.79,2.33,4.85,1.26,6.7,8.54,3.49,1.84-4.66.29,2.14,2.43,7.67-2.52,3.79-2.14,3.49-12.23-1.75-19.02-.39-1.94-9.32-15.53-7.96-11.26-4.46-9.22,3.79,3.2.78-.58,1.65,8.06,4.27,6.11-4.17-8.15.19-3.88-12.52-15.24-3.01-4.76-3.98-8.06-2.72-6.79-2.14-2.43-.49-3.11-.1-.1-6.7-.39-2.62,2.04-1.46,7.47-1.36-3.49-45.81,5.73-3.3-5.14.1-.1h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'GA',
            class: 'cls-1',
            d: 'm836.59,374.87l-.1-2.91-.68,2.52.78.39h0Zm1.07-4.46l-.39-2.23-.29,1.36.68.87Zm-45.43-61.15l-1.26.29-3.69.78-13.59,2.81-1.26.29-1.36.19-7.57,1.46-2.04.39-8.25,1.55-1.75.19.1.19,13.01,39.6,7.18,12.81-1.75,1.94-1.07,7.57,2.14,3.88.19,7.09,2.62,4.95v.1l-.1.1,3.3,5.14,45.81-5.73,1.36,3.49,1.46-7.47,2.62-2.04,6.7.39h0l-.58-10.48,1.26-2.23-.68-4.17,1.36-3.98,2.04-2.23-1.46-1.36,3.4-4.17h-.1l-5.82-5.44-7.96-11.36-4.37-2.04-18.73-15.72-4.56-5.82-8.83-3.69-.49-1.94,2.72-5.34h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'MS',
            class: 'cls-1',
            d: 'm707.5,421.56l-.49.1v.1l.49-.19h0Zm9.03-1.16h-1.36l1.26.1.1-.1h0Zm-11.26.97l-.39.39.1.1.29-.49h0Zm9.12-.78h-3.69l3.49.1.19-.1Zm-40.48-92.5v.1l-4.08,6.79.39,5.24-5.53,6.11,1.46,1.75-3.69,15.53,1.75,3.3-.97.68.1,2.14v.68l2.23,5.24-.19,3.2,3.59,4.37-7.38,12.62-1.16,7.57-2.04,3.01,1.36,3.49-1.26,1.26,33.49-3.69-1.16,4.66,4.27,8.35,2.23,2.81v-.1l3.59-4.08,7.57-1.65,6.99.78,1.07-1.36v-.1l-4.95-29.9-.19-21.84-.58-39.8-1.36-.87-.39-.78h-.19l-4.85.68-8.54,1.16-19.41,2.43-2.14.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'SC',
            class: 'cls-1',
            d: 'm792.24,309.26h0l-2.72,5.34.49,1.94,8.83,3.69,4.56,5.82,18.73,15.72,4.37,2.04,7.96,11.36,5.82,5.44h0l.97-4.46-1.55-4.27,4.17,3.11,2.33-1.84-3.98-3.3,4.85-.29,7.57-6.41-.87-1.65,4.66-3.59-.49-1.75,3.4-2.14.19-4.95,5.34-9.9,3.59-4.56.39-.19-21.65-13.69-8.06,1.55-10.97-.39-5.44-2.81-32.22,10.19h-.29,0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'IL',
            class: 'cls-1',
            d: 'm652.17,176.96l-.19.49,3.69,2.33,1.16,2.33,3.88,3.69-.1,3.11-2.14,6.11-4.85,3.49-4.37.87-.87,5.05,1.46.68-1.46,9.9-3.59,2.23.68,3.79-.87.39h0l-.78,4.27,3.11,8.64,11.07,9.32.97,4.46,2.14,2.23,6.99-.39-1.26,6.5-.49,6.99,4.17,3.4,6.6,2.91,3.49,2.72,1.94,5.53-1.07,2.04,6.89,5.63.29.1-.58-.58,1.94-4.56,7.47,2.04,1.84-2.14-1.46-4.27,6.11-3.59-1.65-2.33,1.46-3.3v-.29l-.39-.1.1-8.64,2.14-1.55,3.69-8.64-.78-3.79-2.43-4.56,1.36-5.14-6.79-47.85-.97-1.07-2.52-5.73-2.04-2.14-.87-5.63v-.19l-13.1,1.84-7.86.97-21.16,2.43h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'IN',
            class: 'cls-1',
            d: 'm741.08,179l-14.85,2.62-3.4.68-12.04,1.94-2.52,2.04-3.79,1.75-1.46-.1-1.75-.87-.58-.58,6.79,47.85-1.36,5.14,2.43,4.56.78,3.79-3.69,8.64-2.14,1.55-.1,8.64.39.1.39-.1,1.46-2.72h3.59l4.37-1.46,5.44,2.04.58-2.23,3.11-2.33,4.66.68,2.52-4.95,6.89.58-.1-2.81,6.11-8.06-.97-3.69,4.27-.1,5.24-4.17-1.26-4.76.19-.19-.19-1.65-5.82-34.36-2.62-14.66-.29-1.55-.29-1.26h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'KY',
            class: 'cls-1',
            d: 'm683.91,295.96l-.29-.78-.58-.19-.39,1.26.1.1,1.07-.1.1-.29h0Zm66.39-63.48l-.19.19,1.26,4.76-5.24,4.17-4.27.1.97,3.69-6.11,8.06.1,2.81-6.89-.58-2.52,4.95-4.66-.68-3.11,2.33-.58,2.23-5.44-2.04-4.37,1.46h-3.59l-1.46,2.72-.39.1v.29l-1.46,3.3,1.65,2.33-6.11,3.59,1.46,4.27-1.84,2.14-7.47-2.04-1.94,4.56.58.58.19.39-.87,7.96-.39.19-2.52,1.55-.1.29,2.81-.39,19.61-2.62-.97-3.88,3.3-.1,39.5-5.24,27.76-4.66.39-.29.68-.78,7.28-3.88,5.63-7.38.78-2.52,3.69-2.91,4.66-5.92.68-.97-.29-.1h-2.43l-3.11-1.75-5.53-6.7-1.94-6.79v-.19l-.19-.19-4.08-2.33-1.84-3.11-3.69,3.59-2.33.58-2.91-1.16-2.52,1.94-5.24-2.33-1.36.58-4.95-4.27-2.52-1.26-4.76.58-.78.78h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'NC',
            class: 'cls-1',
            d: 'm880.95,311.01l-1.07,1.07.19.19.87-1.26h0Zm.78-5.63l-.49.78.19.78.29-1.55h0Zm5.82-9.03l-1.46.97-.78,1.16,2.23-2.14h0Zm12.52-6.11l-.58-.39-1.26-.1,1.84.49h0Zm-2.62-.58h-.87l-1.46.78,2.33-.78Zm3.01,1.07l2.81-6.99-1.94,2.91-.87,4.08h0Zm4.17-9.22l1.26-1.84h-.68l-.58,1.84Zm8.15-7.57l-2.14-10.77,1.84,5.63.29,5.14h0Zm-11.84-24.56l-.19.1-.29.1h.1l5.34,9.03,4.17,4.17-9.12-13.39h0Zm-1.75.58l-.78.19h0l.19.1h1.65l-.19-.58h0l-.29.1h-.29v.19l-.19.1-.1-.1h0Zm-89.78,22.13l-.49,1.46.1,4.17-1.07-.1-2.52,5.14-2.81.29-5.24,5.14-2.33-.87-3.01,4.46-7.96,7.18-3.88.97-4.08,3.79-.19,2.52-3.59,1.94.1,4.27v.97l1.26-.29,13.59-2.81,3.69-.78,1.26-.29h.29l32.22-10.19,5.44,2.81,10.97.39,8.06-1.55,21.65,13.69.39-.29,10-4.08.1-5.34,3.59-6.5,3.88-3.69,8.06-5.34,1.07-1.94,2.14.97.97-6.41-1.16,2.23-4.08,1.36-3.88.1,4.76-3.49-1.46-1.55,1.65-3.49-9.12-1.46-.39-.49,7.77-1.46,2.52,1.26,3.2-.29,2.62-1.94,1.94-3.79,1.75-.49-.29-5.34-2.23-2.14-2.23,2.04.49,5.14-1.65-6.31-1.26-.29-9.61,3.98,4.27-4.17.19-1.65,4.46-1.07,1.26-3.3,3.01,1.75-3.2-4.76-2.23-1.94h0l-38.83,11.07-24.75,6.31-25.04,4.66-.1-.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'OH',
            class: 'cls-1',
            d: 'm808.93,185.41l-2.43-10.48-.49-2.14-2.72-11.94-3.49,2.23-7.47,5.73-4.85,5.92-3.79.58-6.99,3.98-3.88-2.33-11.74-1.36h0l-6.21,1.55-6.11,1.46-6.41,1.36-.97.29.29,1.55,2.62,14.66,5.82,34.36.19,1.65.78-.78,4.76-.58,2.52,1.26,4.95,4.27,1.36-.58,5.24,2.33,2.52-1.94,2.91,1.16,2.33-.58,3.69-3.59,1.84,3.11,4.08,2.33.19.19h0l4.17-2.04,1.46-3.2-1.16-3.3,3.3-5.05,2.43-.39-.29-4.27,3.98-5.44.68.78,3.59-2.72,3.11-4.66.49-21.26.19-.1-.49-2.04h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'TN',
            class: 'cls-1',
            d: 'm777,279.27l-27.76,4.66-39.5,5.24-3.3.1.97,3.88-19.61,2.62-2.81.39v.1l-.78.97-.39-.1v-.87l-1.07.1.1.1.58,2.72-1.94,2.43-.19,4.46v.87l-2.91,5.63.58,3.98-2.72,4.27.97,3.88-3.49,3.2.19.19,2.14-.19,19.41-2.43,8.54-1.16,4.85-.68h.19l-.1-.19,16.31-2.23,7.77-.97,15.53-2.52,2.91-.49,1.75-.19,8.25-1.55,2.04-.39,7.57-1.46,1.36-.19v-.97l-.1-4.27,3.59-1.94.19-2.52,4.08-3.79,3.88-.97,7.96-7.18,3.01-4.46,2.33.87,5.24-5.14,2.81-.29,2.52-5.14,1.07.1-.1-4.17.49-1.46-1.55.29-5.53,1.55-6.6,1.36-16.6,3.4-1.75.29-.39.29h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'VA',
            class: 'cls-1',
            d: 'm899.49,249.76h.29l.29-.1h0l-.19-.49-.39.58h0Zm-3.3-10.87v.49l.49-.29-.49-.19Zm1.75-3.4l-.1-.78h0l.1.78Zm-.58,1.16l-.19,1.26-.29.49.49-1.75h0Zm.87-2.52l.1-.58-.19.58h.1,0Zm.58-2.62l.29-.68-.49,1.75.19-1.07Zm.1-1.46l.39-2.14-.49.49.1,1.65h0Zm1.75-9.61l.19-.87-.1.19-.1.68h0Zm-.39-2.23l-1.26.49-1.94.87-.68.87.29.1-2.33,14.46.87,2.33,1.36-6.02,2.52-7.86,1.16-5.14v-.1h0Zm1.94-.78l-.29.1-.1.39-.49,3.01.39-1.07.49-2.43h0Zm-101.43,37.18l-.68.97-4.66,5.92-3.69,2.91-.78,2.52-5.63,7.38-7.28,3.88-.68.78,1.75-.29,16.6-3.4,6.6-1.36,5.53-1.55,1.55-.29.1.19,25.04-4.66,24.75-6.31,38.83-11.07h0l-.29-.49-.1-.29.68.68h0l.78-.19-.1-.1-.68-3.3.49.1,1.55,2.91h0l.29-.1.19-.1-.39-.78-3.98-6.11-4.95.87-2.23,1.84-2.14-1.94-7.28-2.43-5.05-.19,9.8-.87,5.44,3.69,1.55-2.43-4.37-5.53,3.11.19-1.65-4.46-3.88.19-9.22-7.47h-1.16l13.01,6.41-.87-4.46.87-1.46-6.6-2.52-5.73-.39-2.81-2.52-2.33,1.46-.87-6.7.97.19-.19-5.44-.19-.19-.19.1-.19-.1-.49-.39-.29-.29-3.11-1.36-3.2-2.33-4.46-1.16-.29-.1v.1l-.58,4.08-9.03-3.88.19,5.63-4.95,9.42-3.01,3.3-1.94,5.73-5.92-2.04-2.91,13.2-2.33,4.46-.39,5.82-1.75,2.81-6.5,1.94-5.34,4.17-2.52.39-2.43,2.14-6.11-2.23-1.07-3.01-.19-.1h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'WI',
            class: 'cls-1',
            d: 'm696.53,113.58l-2.43,3.01-1.46,4.37.68,2.43,3.2-9.8Zm-55.71-22.81l1.46-2.04-1.07.97-.39,1.07Zm2.23-3.2l-.49-.58-1.07.68,1.55-.1h0Zm-21.16,5.44l-2.23,2.52,1.07,11.65-6.21,5.63-1.16,5.44,3.4,3.11-.97,13.39,3.59,2.72,2.33.19,7.38,4.46,4.66,4.85,5.92,3.01,1.36,7.47v.49h0l2.81,3.4-.78,2.62.97,5.73,2.91,3.98,5.34,2.81-.1.49h0l21.16-2.43,7.86-.97,13.1-1.84-.39-1.46v-4.56l-2.62-4.85-.68-6.11,1.26-6.79-.68-5.24,2.33-6.5-.87-1.07.19-6.02,1.26-4.56-1.46-1.55-2.81.97-1.55,4.08-3.69,2.14,1.16-5.14,3.3-4.37.19-1.94.1-.1-4.66-4.66v-6.6l-5.24-4.27-7.18-.49-7.38-1.94-15.92-4.85-3.11-1.75-.29.29-4.95-.68-1.65.97.68-7.09-7.96,4.08-9.71,1.55-.1-.19h0Zm19.02-5.14l-.19-.68-.68.29.87.39Zm-3.49-.68l.29-.58-.19-.19-.1.78h0Zm7.09-1.65l-.29-1.36-.29,1.65.58-.29Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'WV',
            class: 'cls-1',
            d: 'm827.47,202.49l-13.78,3.4-4.27-18.44h0l-.19.1-.49,21.26-3.11,4.66-3.59,2.72-.68-.78-3.98,5.44.29,4.27-2.43.39-3.3,5.05,1.16,3.3-1.46,3.2-4.17,2.04h0v.19l1.94,6.79,5.53,6.7,3.11,1.75h2.43l.29.1.19.1,1.07,3.01,6.11,2.23,2.43-2.14,2.52-.39,5.34-4.17,6.5-1.94,1.75-2.81.39-5.82,2.33-4.46,2.91-13.2,5.92,2.04,1.94-5.73,3.01-3.3,4.95-9.42-.19-5.63,9.03,3.88.58-4.08v-.1h0l-2.81-4.85-5.82-.68-3.4,2.62v1.94l-2.91.68-4.27,3.01-2.23.49-4.46,6.31-2.23-10.19-1.94.49h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'DE',
            class: 'cls-1',
            d: 'm884.54,186.47l.39,1.46,8.06,23,9.22-2.72-.1-.19h.19l.29.1h0l.19-.1-.19-.39-2.33-6.21-11.36-10.77.49-7.47h-2.33l-1.75,1.36-.78,1.94h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'DC',
            class: 'cls-1',
            d: 'm868.92,207.92l.49.39.19.1.19-.1.19.1.68.39.19.29v.68l.19.39,1.26-2.33-1.36-.78-1.65.1-.39.78h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'MD',
            class: 'cls-1',
            d: 'm902.31,217.05l.68-5.24-.58,3.88-.39,1.65-.1.19.29-.1.1-.39h0Zm.49-9.03l-.19.1.19.58v1.16-1.84h0Zm-73.38-6.02l2.23,10.19,4.46-6.31,2.23-.49,4.27-3.01,2.91-.68v-1.94l3.4-2.62,5.82.68,2.81,4.85h0l.29.1,4.46,1.16,3.2,2.33,3.11,1.36.29.29.39-.78,1.65-.1,1.36.78-1.26,2.33v.1l-1.84,5.63,6.02,3.88,6.02.29,3.98,1.84-1.65-4.66-5.14-1.75-1.26-3.98,3.2,4.27,2.62.39-2.33-2.33-1.84-6.89.49-3.98-2.04-4.37,2.14-1.75,1.55-5.63-.58,8.35,1.65,2.81,1.55-3.3.87,5.44-1.65,3.98,4.76,1.75-4.08,1.36,2.14,3.98,3.49,1.16,1.94-3.4-.19,4.76,3.3-.1,2.14,2.43h.1l.68-.87,1.94-.87,1.26-.49-.1-.19,2.52-7.47v-.29l-.49-1.94v-.1l-9.22,2.72-8.06-23-.39-1.46-1.65.49-6.89,2.14-37.95,10.58-6.89,1.84-1.75.49h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'NJ',
            class: 'cls-1',
            d: 'm907.55,186.09l-.49-1.16v1.16h.49Zm.97-3.59l.29-2.91-.58,2.52.29.39h0Zm-3.98-29.8l-10.19-2.52-1.75-.49-1.65-.39h0l-4.08,9.03,1.75,2.14-.1,6.5,1.84.29,3.79,9.9-.19.29-4.76,6.99.49,5.34,11.45,3.88.1,4.46,2.62-3.69.39-5.34,2.72-1.84-1.07-3.98,2.04-4.76v-10.39l-.68-3.4-4.56.1,1.16-4.66.68-7.47h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'NY',
            class: 'cls-1',
            d: 'm904.25,160.56l-1.46,2.04-.39.58,1.84-2.62Zm13.39-4.76l4.85-4.27v-.19l-4.85,4.46h0Zm-12.72,3.01v-3.3l-.29,1.75.29,1.55Zm22.52-15.53l-1.16-.29-.19.87,1.36-.58Zm2.62-1.75l-.1.97.19-.58-.1-.39h0Zm-2.72.1l-6.5,6.02-10,4.27-2.62,2.23-.19,2.14-2.72,2.23.39,2.91,4.17-1.65,6.11-4.95,6.79-3.59,10.29-9.71-7.28,5.53-2.33.97,3.88-6.41h0Zm3.01-4.08l.39-.58-1.16,1.36.78-.78Zm-109.1-3.59l-1.55-.19,1.16,1.55.39-1.36h0Zm32.22-29.7l.19-1.07-.78.97.58.1h0Zm.49-6.99l-.39.19-.49,1.07.87-1.26h0Zm-41.06,55.13l.68,2.91,5.14,1.26,29.51-8.06,29.7-8.93,5.44,4.17,1.07,2.43,6.31,2.72.19.39,1.65.39,1.75.49,10.19,2.52-.19-.49.87,3.98,1.94-.49,1.07-4.37v-.1l-1.75-1.65,2.52-3.11-1.16-1.46-3.69-14.27-.19-.97-.49-.29-.29-4.27-.29-4.66-.29-5.05v-.29l-.19.1-4.85-15.92-5.14-8.06-1.46-9.61-4.37-10.19-.58.29-20.29,6.79-4.08,4.37-4.56,8.74.19,1.94-6.02,9.12,3.69,1.26,1.07,6.89-4.27,5.63-12.81,7.77-2.43-.97-9.51,1.36-8.83,5.34.49,2.81,3.11,2.72-1.75,8.54-6.99,8.15-.1.1h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'PA',
            class: 'cls-1',
            d: 'm890.76,148.91l-6.31-2.72-1.07-2.43-5.44-4.17-29.7,8.93-29.51,8.06-5.14-1.26-.68-2.91-1.65,1.26-2.62,1.84-4.76,4.85-.58.49,2.72,11.94.49,2.14,2.43,10.48.49,2.04h0l4.27,18.44,13.78-3.4,1.94-.49,1.75-.49,6.89-1.84,37.95-10.58,6.89-2.14,1.65-.49h0l.78-1.94,1.75-1.36h2.33l.29-.87,3.79-4.27.39-.68.29-.19-3.79-9.9-1.84-.29.1-6.5-1.75-2.14,4.08-9.03h0l-.19-.39h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'ME',
            class: 'cls-1',
            d: 'm937.54,97.18h-.1l.19.1-.1-.1h0Zm7.18-20.67l-.78-1.16v.58s.78.58.78.58Zm-1.36-1.07v-.97l-.1-.58s.1,1.55.1,1.55Zm3.49-4.08l-.19-.1.1.29.1-.19h0Zm9.71-4.85l-.19-1.46-.39.68.58.78Zm-2.43.58l.1-1.07-1.16.19,1.07.87h0Zm3.59-3.2h-.39v.19l.39-.19Zm-4.85,1.46l-.87-.19-.1.87.97-.68h0Zm4.95-3.01l.87.68-.29-.78-.58.1Zm-2.62.1l-.87,1.65,1.16-.58-.29-1.07h0Zm-4.17.1l-.39.58.29.87.1-1.46h0Zm5.73-3.2l-.1-.78-.29.49.39.29h0Zm-.49.39l-.87-.78v.68l.87.1Zm-5.44,2.23l-.19-1.07-.39.87.58.19Zm9.22-3.4l-1.46,2.14-.1-1.55,1.55-.58Zm7.09-6.5l-.68-.97-.39.19s1.07.78,1.07.78Zm2.62-4.37l-.58-.29-.1.29h.68Zm1.26-7.57h-.87l.97.29-.1-.29h0Zm1.46.97l-.29-1.75-.78-.1s1.07,1.84,1.07,1.84Zm-1.55-1.55l-.19-1.84-.68,1.26.87.58h0Zm-56.3,15.24l14.07,33,.19.68,6.11,7.47v-.1l.97-.29.19-5.53,1.55-1.94.97-5.14-.87-.87,1.65-5.05,5.63-2.62,3.69-4.46,1.36-7.77,5.92-.39-.78-3.98,7.38-2.81.49-4.37,1.75.39,4.85-3.98,2.14-5.14-4.95-4.95-5.24-1.07-1.94-3.98v-2.33l-3.2.97-3.59-1.26v-3.98l-9.71-20.97-7.09-3.69-7.86,6.6-2.14-.39-1.84-3.4-2.52.97-3.59,17.86,1.26,5.82,1.07,11.84-2.81,9.12,1.94,1.46-2.33,4.46-2.52-.39-.19.19h0Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'MI',
            class: 'cls-1',
            d: 'm710.7,116.98l-.49-.78-.1.97.58-.19Zm1.55-1.75l-1.16-1.55-.19.68,1.36.87Zm.97-6.99l-.97-.87v.19l.97.68Zm-2.43,76l12.04-1.94,3.4-.68,14.85-2.62.29,1.26.97-.29,6.41-1.36,6.11-1.46,6.21-1.55-.1-.29,3.2-6.31-.29-5.24,3.59-9.03,2.81,1.65,1.07-2.04-.29-7.77-2.62-4.85-3.88-10.29-3.4-3.79-1.75-.49-6.31,4.37.68.87-3.3,6.21-3.2-.58-.97-6.5,1.36-.49,2.81-6.5.29-11.45-4.37-9.71-9.71-1.65-.97-1.46-9.03-2.62-4.08,5.05.39,4.37-3.11,3.88.68,6.02-3.01,2.14v-7.57l-2.72,5.73-3.2,5.05-2.14,1.65,1.07,5.34-1.36,5.53.78,6.89-.97,3.4,6.99,13.39.87,5.14-.87,9.51-4.66,10.68-.58.39h0Zm20.77-87.45l-2.52.19,1.55,1.16.97-1.36h0Zm-14.75,2.52h-.78l.87.39-.1-.39Zm16.99-12.33l-.97-1.55-.39.1,1.36,1.46h0Zm-87.94,7.09l3.11,1.75,15.92,4.85,7.38,1.94,7.18.49,5.24,4.27v6.6l4.66,4.66v-.1l3.79-10.97,4.56-3.2,3.49-3.88.58,3.49,3.59-5.53,8.64-3.3.68-1.36,8.74,1.07,3.4,1.75,1.65-4.27,1.55.97,6.79-1.07-1.65-2.72-3.01-1.75.58-6.31-5.92,3.3-5.44-.68-1.75-4.17.58-1.36-7.38,3.49-4.76.29-8.54,5.24-.97,1.94-5.24-1.26-3.3,1.46-6.6-5.73-14.66-4.46-.29-1.75-9.42,9.03-5.34,1.36-7.57,5.73-.29.19h0Zm34.36-22.03l-11.36,5.63,3.79,3.69,1.46-3.69,3.88-4.76,2.23-.87h0Zm-12.72-13.3l-7.77,5.34-.39,2.62,6.11-4.46,2.04-3.49Z',
          },
          children: [],
        },
        {
          name: 'path',
          type: 'element',
          value: '',
          attributes: {
            id: 'AK',
            class: 'cls-1',
            d: 'm92.02,521.73l-.49.19.39.1.1-.29h0Zm3.59.58h0v.1-.1Zm-1.75-1.65v.29l.19-.1-.19-.19h0Zm-.87-.49v-.1h0v.1Zm1.84.97v-.19l-.1.1.1.1h0Zm-.19-.19v-.1h-.19l.19.1Zm-75.71-63.77l-.1.68.19,1.94s-.1-2.62-.1-2.62Zm-.49-2.62l.1.87.1-.29s-.19-.58-.19-.58Zm76.19,65.23l.1-.58-.39.19.29.39h0Zm11.07,4.76l-.1-.1.19.39-.1-.29h0Zm-7.18-3.4l-1.07-.97v2.33l1.07-1.36Zm2.43,2.14l-.1-.68-1.65-.1,1.75.78h0Zm5.82,1.36l-.1.19h.19l-.1-.19h0Zm.39.1h-.19l.39.1-.19-.1Zm1.16.39h-.19.19Zm-85.71-65.81l.39.1.29-.1h-.68Zm83.57,64.45l-.78-.1.29.29.49-.19h0Zm-88.81-72.02l-1.36-.58-.1.29,1.46.29h0Zm91.24,72.21l-.19-.1v.1h.19Zm5.92,1.16l-3.79.29-.87.39s4.66-.68,4.66-.68ZM10.49,436.51h-1.07l.19.29s.87-.29.87-.29Zm115.8,93.08v-.39h-.19l.19.39Zm5.05.1l.19-.19-.19-.19v.39Zm3.79,1.07l.19-.1h-.1l-.1.1h0Zm-3.11-1.75l-.1-.39h-.19l.29.39h0Zm6.5,1.46l-.1.1h.1v-.1ZM11.07,431.56l-1.46.19,1.84,1.65-.39-1.84h0Zm122.3,97.45l.19-.58h-.1l-.1.58h0Zm16.4-1.46l.1-.19-.19-.1.1.29h0Zm-2.43-.87l-3.4,3.01,2.43-.19,2.81-2.23-1.84-.58h0Zm6.11,1.07l-.68-.19.49.39.19-.19h0Zm1.36.1l-1.07-.29-.19.1,1.26.19Zm-3.69-1.36h-1.07l1.84.49-.78-.49Zm4.46.97l-.1-.19-.39.1.49.1h0Zm-2.91-1.16l-.39-.19v1.07l.39-.87Zm12.42,2.43l-.1-.1h-.19l.29.1h0Zm.19-.1v-.1l-.19-.1.19.19h0Zm-1.65-.58l.19.39v-.1l-.19-.29h0Zm.87,0l-.87-.29,1.07.78-.19-.49Zm1.26-.97h0v.1-.1Zm11.55,1.46l-.19-.39h-.1l.29.39h0Zm104.44-6.5l-.19-.19.1.19h.1,0Zm-117.64,3.01v-.1l-.1.1h.1Zm120.46-4.76l.29.39h.19l-.49-.39Zm-106.09,7.28l-.1.1v.29l.1-.39h0Zm-12.04-1.75l.19-.78h-.1l-.1.78h0Zm123.76-7.77l-.87.49.78.39.1-.87h0Zm-122.01,7.28l-.1-.19.1.19h0Zm-7.28-2.14l-2.43.49-2.14,2.81,4.56-3.3h0Zm17.37,3.69l-.58.49.58-.1v-.39h0Zm111.91-9.32l-.19-.39-.1.19.29.19h0Zm-121.23,6.79l-.68-.1.68.68v-.58h0Zm114.83-5.53l-.19.19.19.68v-.87Zm-113.27,5.44l-.29.1.39.29-.1-.39h0Zm7.18,2.04h-.29l-.19-.19.49.19Zm-7.96-2.04l-.49-.29.19.29h.29Zm6.5,1.07l-.87.29-.58,1.55,1.46-1.84h0Zm105.41-6.79v.68l.39-.49-.39-.19h0Zm-116.86,3.69l.78-.19h-.1l-.68.19h0Zm-.97-.58l-.19-.19v.1l.19.1h0Zm117.83-3.79l-.19-.1-.1.29.29-.19h0Zm-106.48,5.82l-.19-.1-.19.29.39-.19h0Zm105.51-5.63l.1-.49-.19-.1.1.58h0Zm-.78-.49l-.29.39.49.1-.19-.49h0Zm-100.65,4.76l-.19-.19h-.1l.29.19h0Zm100.36-6.5l.78.29.29-.39-1.07.1h0Zm1.16-.68l-.29.19.49.29-.19-.49Zm-2.23.58l-.19-.39-.19.19.39.19h0Zm9.71-3.59l-1.26,3.59,1.26-.78v-2.81Zm-115.02,7.47h-.1.1Zm106.48-6.11l-.87.87.19.97.68-1.84h0Zm-90.37,7.77v-.39l-.1.19.1.19Zm89.3-8.74l2.81,4.27,6.31,3.98-1.46-3.4-6.02-5.14-1.65.29h0Zm-93.18,7.18l-.1-.29-.19.1.29.19h0Zm96.48-8.83l-.39,1.46.68-.49-.29-.97h0Zm2.04,0l-.1.97.87.29-.78-1.26h0Zm-95.41,7.57l-.49-.1-.49.19.97-.1h0Zm10,.78l-.39.68.19-.58.19-.1h0Zm1.46.1l-.87.1.49.58.39-.68h0Zm-58.82-12.42l.97.49-.19-.19-.78-.29h0Zm38.53,9.61l.1-.1-.1.1h0Zm.29-.1h.1v-.1l-.1.1Zm100.36-7.47l.49,1.84.97-.58-1.46-1.26h0Zm-97.74,6.41l.1-.1h0l-.1.1Zm93.57-5.63l.49,4.46.97-.97-1.46-3.49Zm.49-1.46l2.23,3.11-.29-2.04-1.94-1.07Zm-6.89.78l-.58,1.84.78-1.26-.19-.58h0Zm-77.65,4.76l-.1-.1.1.1h0Zm9.22.19l-.19-.29.19.39v-.1h0Zm68.62-6.41l3.88,6.41-.58-4.37-3.3-2.04h0Zm-63.19,3.4l-.29.29.49.19-.19-.49h0Zm-1.26.19l.1-.29h-.39l.29.29h0Zm-.97,0l-2.52,1.65-3.11,4.08,1.55,1.65,7.18-5.34-3.11-2.04Zm61.25-6.31l-.68-.39v.58l.68-.19h0Zm-61.83,5.14l.1.39.68.39-.78-.78h0Zm63.67-6.99l-1.94.97,1.84.58.1-1.55h0Zm-1.26,0l-.19-.19-.1.19h.29Zm5.92-1.55l-.78-.29-.19.58.97-.29Zm-4.17.68l-.68-.1v.19l.68-.1h0Zm2.14-.78l3.98,5.82-1.07-5.34-2.91-.49h0Zm-64.06,6.31l-2.33,1.75,1.07,1.16,3.11-2.33-1.84-.58h0Zm-26.4-3.69l-.1-.1v.1h.1Zm-1.07-.49l-.1-.49v.19l.1.29Zm29.8,1.26l-.19.1v.1l.19-.19h0Zm-.97-.19h-.1l-.19.29.29-.29h0Zm2.33-.78l-.29-.19v.1l.29.1h0Zm.78-.1l-.29-.19v.1l.29.1h0Zm-1.26-.29h-.39v.1l.39-.1Zm19.32-1.94l.1-.29-.19.19.1.1h0Zm5.92-3.11l1.16-1.46-.39.29-.78,1.16Zm-11.84-.19l.39-.29.1-.39-.49.68h0Zm0-1.07l-.39.29.68-.19-.29-.1Zm-15.92,0l-.1-.39h-.1l.19.39h0Zm15.53-.1l-.39.39-.19.39.58-.78Zm10.68-1.16h.19-.19Zm.49,0l-.19-.1v.1h.19Zm-1.16-.1l.1.1v-.1h-.1Zm-7.96.58l.39-.39-.49.39h.1,0Zm5.92-1.16h0Zm-4.76.29l-2.33,3.79,3.01-3.49-.68-.29Zm-3.01.49l-.29-.39-.1.19.39.19h0Zm7.38-.87l-.19-.1.1.1h.1,0Zm2.52.19v-.68l-.19.29.19.39Zm-71.24-7.47l-4.66-.19,3.2,3.4,1.46-3.2Zm66.29,6.89l.19.68.49-.78-.68.1h0Zm-3.88-.1l-.29,2.14.49-1.36-.19-.78Zm-84.25-16.11l.1-.39h0l-.1.39Zm83.28,14.75l.1.29.19-.1-.29-.19h0Zm-.49.39l-.19-.58-.29.19.49.39Zm4.56-1.16v-.39l-.29.19.29.19h0Zm-4.37-.58v.97l.29-.68-.29-.29Zm-7.38-1.16v-.29h0v.29Zm-50.67-12.04l.19-.58-.1.1-.1.49h0Zm.29-.97l-.1-.1-.1.1h.19Zm4.27-2.33v-.1h0v.1Zm0-.39l-.1-.19h0l.1.19Zm1.75-2.52h-.1.1Zm.58.19l-.39-.19v.1l.39.1h0Zm-.58-.39v-.19l-.19.19h.19Zm-15.53-4.56l-.19-.49-.1-.29.29.78h0Zm1.46-1.75h.1l.1.1-.19-.1h0Zm-2.62-.49l-.78-.97.58.78.19.19h0Zm-1.55-1.55h-.19l.29.1-.1-.1h0Zm.19-1.07h0Zm-.19-.1h0l.19.1-.19-.1Zm25.72,7.67l-1.07.1.58.29.49-.39h0Zm-26.79-9.42l-.78,2.91,2.43.39,3.2,3.3,1.94-.87-6.79-5.73Zm16.99,1.16v-.19.19h0Zm-4.85-10.29l-.19-.1.1.1h.1,0Zm2.81.97l.29-.1h-.1l-.19.1h0Zm1.94-.58h.29l.87-.39-1.16.39h0Zm3.49-1.07l.19-.19-.29.19h.1,0Zm.49-.1l.58-.29-.49.1-.1.19h0Zm1.46-.58l-.49.1v.1l.49-.19h0Zm.58-.1h0Zm61.73-17.47l-.39-.29-.68-.29,1.07.58h0Zm-50.86-2.14l.87-1.16-.49.39-.39.78h0Zm1.16-1.36l.39-.58-.19.19-.19.39h0Zm.58-.78l.68-.58-.39.19-.29.39h0Zm30.57.19l.49.49h.29l-.78-.49Zm-15.63-6.41l-3.98,3.3-2.43-.68-5.63,3.2-1.07-.68-6.41,7.18-6.5,1.46.58,3.49,2.91,3.98,5.44,5.24-.87,2.04,4.08,1.75-2.14.39-2.62-2.04,1.36,3.01-1.75,1.07-5.53-5.05-4.37.78-7.47,2.81,3.4,3.79-.49,2.33,2.23,2.72,7.38,2.91,5.34-2.72.87,2.04-1.46,6.11h-4.46l-5.24,2.33-.29-1.65-2.72,1.07-1.26,2.81-4.46,3.4v4.95l1.75.78-1.36,4.17,5.82,5.05,3.69-1.55-.78,6.21,1.07,1.36,4.46.97,1.65,1.84,3.88.29,1.84,1.94,3.98-1.16-1.84,2.52-1.46,5.14-11.84,7.67-1.55,1.55-2.23-.87-3.59.87-5.14,3.4,8.06-2.33,1.16,1.75,10.39-3.4.29,1.36,4.08-4.08,8.54-5.92.68.39,7.47-5.92-1.94-2.33,2.52-4.17,6.6-7.86,5.05-.97,1.55,1.07-6.11,1.75-1.65,6.5.19,3.49,2.14-.19,10.29-6.21.78-2.33-.87-3.59,3.11.78,2.23-1.46,6.41,3.88-.49,1.07,14.56,1.84,3.4-1.07.97,1.46,12.62,6.02,2.14-1.26.19-7.28,1.65,3.3,8.15,5.92.68,2.43,7.09,3.98,1.84,5.14,1.75-3.98,3.59,6.99,2.43-3.98-1.94-4.95-7.47-.78-11.45-10.97-6.21-4.56-4.76,4.66h-2.81l-6.5-4.27-6.41-.29-9.12-57.56-1.55-2.72-3.69-2.23-5.53,1.07-4.27-.87-5.44-2.14-5.73.39-1.46-2.72-4.56-.68-.78-1.65-2.04,2.33-.58-4.37h0Z',
          },
          children: [],
        },
      ],
    },
  },
};
